import { Global } from '@emotion/react';
import { useMemo } from 'react';

import { themeValues, themeVars } from './theme';

export const GlobalThemeProvider = () => {
  const styles = useMemo(() => {
    const res: Record<string, string> = {};

    for (const key in themeVars.text) {
      const typedKey = key as keyof typeof themeVars.text;
      const varName = themeVars.text[typedKey].replace('var(', '').replace(')', '');
      res[varName] = themeValues[typedKey];
    }

    return res;
  }, []);

  return (
    <Global
      styles={{
        ':root': styles,
      }}
    />
  );
};
